import { useMemo } from 'react';
import { useLocation } from '@tanstack/react-router';

import { routeOptions } from '@/components/navigation/left/constants';

/**
 * Hook to get the current route ID based on the pathname
 * Returns the AtlasRouteId that corresponds to the current page
 */
export const useCurrentRoute = (): string | undefined => {
  const pathname = useLocation({
    select: (location) => location.pathname,
  });

  return useMemo(() => {
    // Extract the last segment of the pathname
    // e.g., "/org/facility/alarms" -> "alarms"
    const segments = pathname.split('/').filter(Boolean);

    if (segments.length < 3) {
      // Not on a facility page
      return undefined;
    }

    // The page name is the last segment
    const currentPath = segments[segments.length - 1];

    // Find the route config by matching the path
    const route = routeOptions.find((r) => r.id === currentPath);

    return route?.id;
  }, [pathname]);
};
